export * from './badge-status-produto-beneficiario.pipe';
